export default {choose_newsletter:'Elija boletines en la lista.',email_please:'¿Tu email?'};